import * as React from 'react';
import { connect } from 'react-redux';
import { IApplicationState } from '../../store/ApplicationState';
import { actionCreator, IActions } from '../../common/store/posts/actions/creators';
import { IState } from '../../common/store/posts/state';
import { StyledComponentProps, withStyles, Grid } from '@material-ui/core';
import ListPost from './components/ListPost';
import { styles } from './styles';
import Search from './components/Filter/Filters';
import { Export } from './components/Export';

interface IProps extends IActions, IState, StyledComponentProps { }

class CompContainer extends React.Component<Partial<IProps>>
{
    componentDidMount() {
        this.props.loadDrafts();
    }

    render() {
        const { posts, deliverPost, getPost, deletePost } = this.props;
        return (
            <Grid container>
                <Grid item sm={12}>
                    <Search loadDrafts={this.props.loadDrafts} />
                </Grid>
                <Grid item sm={12}>
                    <ListPost
                        classes={this.props.classes}
                        postList={posts}
                        deliverPost={deliverPost}
                        getPost={getPost}
                        deletePost={deletePost}
                        navigateTo={this.props.navigateTo}
                    />
                     {this.props.posts && this.props.posts.length > 0 && <Export print={() => {window.print()}} download={() => {  }} />} 
                </Grid>
            </Grid>
        );
    }
}
const mapStateToProps = (state: IApplicationState, ownProps: Partial<IActions & IState>) => {
    return {
        ...ownProps,
        ...state.posts
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        ...actionCreator(dispatch)
    }
};

export const PostSending = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(CompContainer));